export const getVideoList = (type: string) => {
    const defaultValue = [
        {
            id: 1,
            title: "Creating a Non-MLS Listing",
            duration: "1 min 04 secs",
            thumbnail:
                "https://storage.googleapis.com/marabot-main/create-non-mls-listing.png",
            active: true,
            link: "create-non-mls-listing",
        },
        {
            id: 2,
            title: "Creating a MLS Listing",
            duration: "1 min 00 secs",
            thumbnail:
                "https://storage.googleapis.com/marabot-main/create-mls-listing.jpg",
            active: false,
            link: "create-mls-listing",
        },
        {
            id: 3,
            title: "Creating a Campaign",
            duration: "1 min 43 secs",
            thumbnail:
                "https://storage.googleapis.com/marabot-main/create-campaign.png",
            active: false,
            link: "create-campaign",
        },
        {
            id: 4,
            title: "Creating a slideshow",
            duration: "1 min 12 secs",
            thumbnail:
                "https://storage.googleapis.com/marabot-main/create-slideshow.png",
            active: false,
            link: "create-slideshow",
        },
        {
            id: 5,
            title: "Using Videos",
            duration: "1 min 09 secs",
            thumbnail:
                "https://storage.googleapis.com/marabot-main/using-videos.png",
            active: false,
            link: "using-videos",
        },
        {
            id: 6,
            title: "Schedule an Open House",
            duration: "57 secs",
            thumbnail:
                "https://storage.googleapis.com/marabot-main/open-house.png",
            active: false,
            link: "schedule-an-open-house",
        },
        {
            id: 7,
            title: "Creating a Neighborhood Expert Campaign",
            duration: "1 min 28 secs",
            thumbnail:
                "https://storage.googleapis.com/marabot-main/create-promotion-campaign.png",
            active: false,
            link: "create-neighborhood-expert-campaign",
        },
    ];
    switch (type) {
        case "create-non-mls-listing":
            return defaultValue.map((item) => ({
                ...item,
                active: item.id === 1,
            }));
        case "create-mls-listing":
            return defaultValue.map((item) => ({
                ...item,
                active: item.id === 2,
            }));
        case "create-campaign":
            return defaultValue.map((item) => ({
                ...item,
                active: item.id === 3,
            }));
        case "create-slideshow":
            return defaultValue.map((item) => ({
                ...item,
                active: item.id === 4,
            }));
        case "using-videos":
            return defaultValue.map((item) => ({
                ...item,
                active: item.id === 5,
            }));
        case "schedule-an-open-house":
            return defaultValue.map((item) => ({
                ...item,
                active: item.id === 6,
            }));
        case "create-neighborhood-expert-campaign":
            return defaultValue.map((item) => ({
                ...item,
                active: item.id === 7,
            }));
        default:
            return [];
    }
};
